import { useMutation, useQueryClient } from '@tanstack/react-query';
import { StatusCode, REACT_QUERY_KEYS } from '@hungryroot/rest';
import {
  postSetPeriodicity,
  PeriodicityTypes,
  type Params,
} from '@hungryroot/rest/api/set_periodicity/post';

export { PeriodicityTypes };

export function usePostSetPeriodicity() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (params: { data: Params }) => {
      const { data } = params;
      const res = await postSetPeriodicity(data);
      if (res.status !== StatusCode.SuccessOK) {
        throw new Error(JSON.stringify(res.data, null, 2));
      }
      return res.data;
    },
    onSuccess(response, params) {
      const {
        data: { product_id, periodicity },
      } = params;
      queryClient.invalidateQueries({
        queryKey: [REACT_QUERY_KEYS.CUSTOMERS, 'periodicities'],
      });
      // dispatch an event here so all UI gets the latest values
      // This is a DOM event because this data is displayed
      // in React and Coffee Script.
      // Once we are 100% on React, we can remove this in favor of refreshing
      // data from the server.
      const evt = new CustomEvent('product-periodicity-changed', {
        detail: {
          productId: product_id,
          periodicity,
        },
      });
      document.dispatchEvent(evt);
    },
  });
}
